import { useEffect, useRef } from 'react';
import { useAtlas } from '../app/store.ts';
import { on } from '../viewport/events.ts';
import { groupLabel, hemisphereLabel } from '../data/catalogue.ts';

/** A small tooltip that follows the pointer over the viewport, naming what's under it. */
export function HoverCard() {
  const ref = useRef<HTMLDivElement>(null);
  const hovered = useAtlas((s) => (s.hoverFrom === 'viewport' ? s.hovered : null));
  const catalogue = useAtlas((s) => s.catalogue);
  useEffect(
    () =>
      on('hover', (e) => {
        const el = ref.current;
        if (el && e.id) el.style.transform = `translate(${Math.round(e.x + 14)}px, ${Math.round(e.y + 18)}px)`;
      }),
    [],
  );
  const s = hovered ? catalogue?.byId.get(hovered) : undefined;
  return (
    <div ref={ref} className={`hovercard ${s ? 'on' : ''}`} aria-hidden="true">
      {s ? (
        <>
          <span className="hc-name">{s.name}</span>
          <span className="hc-meta">{[groupLabel(catalogue, s.system), hemisphereLabel(s.hemisphere)].filter(Boolean).join(' · ')}</span>
        </>
      ) : null}
    </div>
  );
}
